"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Mentions = _interopRequireDefault(require("./Mentions"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _Mentions.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-mentions/lib/index.js
// module id = 1989
// module chunks = 0